import { render, staticRenderFns } from "./inspections-view.vue?vue&type=template&id=6c201ebe"
import script from "./inspections-view.vue?vue&type=script&lang=js"
export * from "./inspections-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports